import { normalizeClassName } from './classNameUtils';

/**
 * 이미지를 미리 로드하여 브라우저 캐시에 저장
 * @param imageUrls - 프리로드할 이미지 URL 배열
 * @returns Promise that resolves when all images are loaded
 */
export function preloadImages(imageUrls: string[]): Promise<void[]> {
  const promises = imageUrls.map((url) => {
    return new Promise<void>((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve();
      img.onerror = () => {
        console.warn(`Failed to preload image: ${url}`);
        resolve(); // 실패해도 계속 진행
      };
      img.src = url;
    });
  });

  return Promise.all(promises);
}

/**
 * 클래스 아이콘 SVG를 미리 로드
 * @param classNames - 프리로드할 클래스 이름 배열
 */
export function preloadClassIcons(classNames: string[]): Promise<void[]> {
  const iconUrls = classNames.map((className) => `/class-icons/${normalizeClassName(className)}.svg`);
  return preloadImages(iconUrls);
}
